module.exports = __webpack_public_path__ + "img/W-1.ecc6f671.jpg";